// extracted by mini-css-extract-plugin
export default {"logo":"header_logo__J3glr","contact":"header_contact__A1Axa"};